export function isKioskDownloadsDisabled() {
    return document.documentElement.classList.contains('is-kiosk');
}

export function kioskDownloadsDisabledMessage() {
    const meta = document.querySelector('meta[name="kiosk-downloads-disabled-message"]');
    const msg = meta?.getAttribute('content')?.trim();
    if (!msg) {
        throw new Error('kioskDownloadsDisabledMessage: meta[name="kiosk-downloads-disabled-message"] is required');
    }
    return msg;
}
